export default __webpack_public_path__ + "static/media/AdminTeams.aed086a9.svg";